import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog } from "@activecollab/components";
import PropTypes from "prop-types";

export const RescheduleSimulationSplitContent = ({ onSubmit, onCancel }) => {
  const { t } = useTranslation();
  return (
    <>
      <Dialog.Title>{t("Task Update")}</Dialog.Title>
      <Dialog.ContentDivider />
      <Dialog.Content>
        {t("Changing the task’s duration will delete all custom estimation splits. Are you sure you want to proceed?")}
      </Dialog.Content>
      <Dialog.ContentDivider />
      <Dialog.Actions>
        <Button
          onClick={onSubmit}
          className="tw-mr-3"
          variant="primary"
          autoFocus
        >
          {t("Continue")}
        </Button>
        <Button
          variant="secondary"
          onClick={onCancel}
          data-action="cancel"
        >
          {t("Cancel")}
        </Button>
      </Dialog.Actions>
    </>
  );
};

RescheduleSimulationSplitContent.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
};
